import {
  gql,
  TransactionTrackingPlugin,
  CancelPlugin,
  LocalePlugin,
  RemoveUnderscoredPropertiesPlugin,
} from '@sbvr/lbe-api';
import { crossEnv } from '@sbvr/lbe-environment';
import { ErrorNotifierPlugin } from '@sbvr/lbe-api/plugins/ErrorNotifierPlugin';
import useFlashService from '@sbvr/lbe-web-panel/flash';

const { showFlash } = useFlashService();
gql.use(ErrorNotifierPlugin, {
  onErrorCallback ({ message }) {
    showFlash({ type: 'error', message });
  },
});

gql.use(LocalePlugin, { locale: crossEnv.BROWSER_LOCALE });
// gql.use(RemoveUnderscoredPropertiesPlugin);
gql.use(CancelPlugin);
gql.use(TransactionTrackingPlugin);

export default gql;
